import { ComponentProps } from 'react';

import { createMockEnvironmentSandbox } from 'dashboard/lib/stubs/environment';
import { createMockInquiryTemplate } from 'dashboard/lib/stubs/inquiry-template';
import { createMockInquiryTemplateVersion } from 'dashboard/lib/stubs/inquiry-template-version';
import { createMockUser } from 'dashboard/lib/stubs/user';
import { InquiryTemplateTier } from 'dashboard/models/inquiry-template';
import { InquiryTemplateVersionStatus } from 'dashboard/models/inquiry-template-version';
import { initialInquiryTemplatesFilterState } from 'dashboard/redux/slices/inquiry-templates';
import DashboardInquiryTemplatesView from 'dashboard/views/DashboardInquiryTemplatesView/index';
import { ApiModel } from 'lib/interfaces/api';
import { Permission } from 'lib/permissions';

export const mockUser = createMockUser({
  'email-address': 'test@withpersona.com',
  permissions: [
    Permission.InquiryTemplateView,
    Permission.InquiryTemplateWrite,
    Permission.InquiryTemplateCreate,
  ],
});

export const mockSandboxEnvironment = createMockEnvironmentSandbox();

export const latestDraftVersion = createMockInquiryTemplateVersion({
  status: InquiryTemplateVersionStatus.Draft,
});

export const latestPublishedVersion = createMockInquiryTemplateVersion({
  status: InquiryTemplateVersionStatus.Published,
});

export const inquiryTemplate = createMockInquiryTemplate(
  {},
  {
    'latest-draft-version': {
      data: { id: latestDraftVersion.id, type: latestDraftVersion.type },
    },
    'latest-published-version': {
      data: { id: latestPublishedVersion.id, type: latestPublishedVersion.type },
    },
  },
);

export const inquiryTemplateEnhanced = createMockInquiryTemplate(
  {
    'pricing-tier': InquiryTemplateTier.Enhanced,
  },
  {
    'latest-draft-version': {
      data: { id: latestDraftVersion.id, type: latestDraftVersion.type },
    },
    'latest-published-version': {
      data: { id: latestPublishedVersion.id, type: latestPublishedVersion.type },
    },
  },
);

export const generateProps = (
  mockFn: Function,
): ComponentProps<typeof DashboardInquiryTemplatesView> => {
  return {
    inquiryTemplates: [],
    legacyTemplateFilters: [],
    inquiryTemplateFilters: [],
    inquiryTemplateBuilders: [],
    builderPreviews: {},
    isLoading: false,
    isCloneLoading: false,
    filters: initialInquiryTemplatesFilterState,
    sortParams: { sort: 'updated_at', shouldSortDescending: true },
    paginationParams: { 'current-page': 1, 'total-count': 50, 'total-pages': 1 },
    pageSize: 50,
    currentEnvironmentType: ApiModel.EnvironmentProduction,
    handlePageLinkClick: mockFn(),
    handlePageSizeClick: mockFn(),
    handleSortUpdate: mockFn(),
    handleStatusFilterUpdate: mockFn(),
    handleOmniSearch: mockFn(),
    handleCreateInquiryTemplate: mockFn(),
    handlePreviewInquiry: mockFn(),
    handlePreviewLegacyInquiry: mockFn(),
    handleActivateInquiryTemplate: mockFn(),
    handleDeactivateInquiryTemplate: mockFn(),
    handleLoadTemplateBuilderPreview: mockFn(),
    handleCloneInquiryTemplate: mockFn(),
    dynamicFlowTemplatesOnly: false,
  };
};
